import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CompsDataService } from "../comps-data.service";
import { AppService } from "src/app/app.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { VAIconRegistryService, close, plus } from "@va/core-library/icons";

@Component({
  selector: "app-comps-ticker-modal",
  templateUrl: "./comps-ticker-modal.component.html",
  styleUrls: ["./comps-ticker-modal.component.scss"],
})
export class CompsTickerModalComponent implements OnInit {
  @Input() addRowTableData: Array<any>;
  @Input() watchlists: Array<any>;
  @Input() recentlyVisitedCompanies: Array<any>;
  @Input() mpt: number;
  @Input() maxHeight: string;
  @Input() type: string;
  @Input() mptApplicable = true;
  @Output() tickerUpdate = new EventEmitter();
  @Output() mptUpdate = new EventEmitter();
  @Input() isTickerTypeBg = false;
  @Input() maxTickers: number;

  watchlisNameInput = "";
  selectedTickers: Array<any> = [];
  recentlyVisited: Array<any> = [];
  modalData: Array<any> = [];
  stdLineItems: Array<any> = [];
  legacyUrl = `${window.caUrl}/app`;
  visible: boolean;
  selectedMenuItem = "";
  lineItems: Array<any> = [];
  watchlistData: Array<any> = [];
  allItems: Array<any> = [];
  recentCompanies: Array<any> = [];
  isLoading = false;
  mptList = {
    1: "Industrial & commercial",
    2: "Banking & Financial Services",
    3: "Insurance",
  };
  constructor(
    private dataService: CompsDataService,
    private message: NzMessageService,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([plus, close]);
  }

  ngOnInit() {
    this.modalData = this.addRowTableData ? [...this.addRowTableData] : [];
    this.watchlistData = JSON.parse(JSON.stringify(this.watchlists));
    this.recentCompanies = JSON.parse(
      JSON.stringify(this.recentlyVisitedCompanies),
    );
    let wData = [];
    for (let i = 0; i < this.watchlistData.length; i++) {
      // this.watchlists[i].company_info.map(el => {
      //   return {...el, isSelected: false};
      // })
      wData = this.watchlistData[i].company_info.map((el) => {
        const addedRowData = this.addRowTableData.find((obj) => {
          return obj.ticker === el.ticker;
        });
        if (addedRowData) {
          addedRowData.isSelected = true;
          const m = el.mpt;
          el = addedRowData;
          el["mpt"] = m;
        }
        // let obj = Object.assign({}, el);
        return el;
      });
      this.watchlistData[i].company_info = JSON.parse(JSON.stringify(wData));
    }
    this.selectedMenuItem =
      this.watchlistData.length && this.watchlistData[0].watchername;
    this.recentlyVisited =
      this.watchlistData.length && this.watchlistData[0].company_info;
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.addColTableData.currentValue !== undefined) {
  //     this.modalData = this.addRowTableData;
  //   }
  //   if (changes.userTabId.currentValue !== changes.userTabId.previousValue) {
  //     const postObj = {
  //       tab_id: this.userTabId,
  //       currency: "USD"
  //     };
  //     this.dataService.getStdLineItems(postObj).subscribe((res) => {
  //       this.stdLineItems = res.data;
  //     });
  //   }
  // }

  addTicker(params) {
    if (this.modalData.length === 0 && this.mpt === null) {
      this.mpt = params[0].mpt;
      this.mptUpdate.emit(this.mpt);
    }
    const tickerExist = this.modalData.filter((data) => {
      return data.ticker === params[0].ticker;
    });
    const mpt = params[0].mpt;
    if (!this.mptApplicable || mpt === this.mpt) {
      if (tickerExist.length === 0) {
        for (let i = 0; i < this.watchlistData.length; i++) {
          this.watchlistData[i].company_info.map((el) => {
            if (params[0].ticker === el.ticker) {
              el.isSelected = true;
            }
            return el;
          });
        }
        params[0].isSelected = true;
        this.modalData.push(params[0]);
        this.tickerUpdate.emit(this.modalData);
      }
    } else {
      this.message.create(
        "error",
        `Error: We currently cannot create a peer analysis table with tickers from BOTH ${
          this.mptList[this.mpt]
        } and ${this.mptList[mpt]} sectors.`,
      );
    }
  }

  onWatchlistSelect(e, d) {
    this.selectedMenuItem = d.watchername;
    this.recentlyVisited = d.company_info;
  }

  onMenuVisibleChange(visible) {
    this.visible = visible;
  }

  addSearchedTicker(tickerInfo): void {
    if (this.modalData.length === 0 && this.mpt === null) {
      this.mpt = tickerInfo.mpt;
      this.mptUpdate.emit(this.mpt);
    }
    const ticker = this.isTickerTypeBg ? tickerInfo.bTicker : tickerInfo.ticker;
    const company = {};
    company["full_name"] = tickerInfo.full_name;
    company["sli_comps_id"] = 0;
    company["ticker"] = ticker;
    company["mpt"] = tickerInfo.mpt;
    company["isSelected"] = true;
    company["cid"] = tickerInfo.cid;
    const mpt = tickerInfo.mpt;

    if (!this.mptApplicable || this.mpt === mpt) {
      const tickerExist = this.modalData.filter((data) => {
        return data.ticker === ticker;
      });
      if (tickerExist.length === 0) {
        this.addTicker([company, false]);
      } else {
        this.message.create("info", "This ticker is already present.");
      }
    } else {
      this.message.create(
        "error",
        `Error: We currently cannot create a peer analysis table with tickers from BOTH ${
          this.mptList[this.mpt]
        } and ${this.mptList[mpt]} sectors.`,
      );
    }
  }

  removeTicker(company) {
    // if(company.sli_comps_id){
    for (let i = 0; i < this.watchlistData.length; i++) {
      this.watchlistData[i].company_info.map((el) => {
        if (company.ticker === el.ticker) {
          el.isSelected = false;
        }
        return el;
      });
    }
    //}
    // else{
    //   company.isSelected = false;
    // }
    //company.isSelected = false;

    const index = this.modalData.indexOf(company);
    this.modalData.splice(index, 1);
    if (this.modalData.length < 1) {
      this.mpt = null;
    }
    this.tickerUpdate.emit(this.modalData);
  }

  addAllTickers() {
    let err = false;
    const len = this.recentlyVisited.length;
    for (let i = 0; i < len; i++) {
      const company = this.recentlyVisited[i];
      if (company.mpt === this.mpt || this.mpt === null || !this.mptApplicable)
        this.addTicker([company, false]);
      else {
        err = true;
      }
    }
    if (err) {
      this.message.create(
        "error",
        `Error: We currently cannot create a peer analysis table with Tickers across Industrial & Commercial, Banking & Financial Services, and Insurance sectors.`,
      );
    }
  }

  removeAllTickers() {
    this.mpt = null;
    this.modalData = this.modalData.filter((item) => item.tickerDeleteDisabled);
    this.tickerUpdate.emit(this.modalData);
    for (let i = 0; i < this.watchlistData.length; i++) {
      this.watchlistData[i].company_info.map((el) => {
        // let obj = Object.assign({}, el);
        el.isSelected = false;
        return el;
      });
    }
  }
}
